import { render, staticRenderFns } from "./ExpandedScope.vue?vue&type=template&id=a4a4c992&scoped=true&lang=pug&"
import script from "./ExpandedScope.vue?vue&type=script&lang=js&"
export * from "./ExpandedScope.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedScope.vue?vue&type=style&index=0&id=a4a4c992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a4c992",
  null
  
)

export default component.exports